import { format } from "@suse-o11y/date-time";
import { toRelativeDateTerm } from "@suse-o11y/date-time/to-relative-date-term";
import { isShallowEqual } from "@suse-o11y/is-shallow-equal";
import { useNow } from "@suse-o11y/use-now";
import React from "react";

import type { MonitorCheckStatusExternalSilencingRule } from "../../../../../../../common/openapi";

export function ExternalRuleTiming({ rule }: { rule: MonitorCheckStatusExternalSilencingRule }) {
	const relativeDateTerm = useNow({
		interval: 100,
		floor: "seconds",
		compare: isShallowEqual,
		transform: (now) => toRelativeDateTerm(now, rule.startTimeEpochMs),
	});

	return (
		<section className="space-y-3">
			<h2 className="text-15/[22px] text-core-text-neutral-primary">Muted</h2>
			<p className="mb-0 text-core-text-neutral-secondary">
				Since {relativeDateTerm}, {format(rule.startTimeEpochMs, "HH:mm:ss")}.
			</p>
		</section>
	);
}
